import React from 'react';
import { Parallax } from 'react-scroll-parallax';
import { motion } from 'framer-motion';
import { galleryImages } from '../mockData';
import './Gallery.css';

const Gallery = () => {
  return (
    <section id="gallery" className="gallery-section section-padding">
      <div className="container">
        <motion.div
          className="gallery-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="heading-1">Moments of Tranquility</h2>
          <p className="body-large">Experience the beauty that awaits you</p>
        </motion.div>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <Parallax key={index} speed={index % 2 === 0 ? -5 : 5}>
              <motion.div
                className="gallery-item"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
              >
                <img src={image.url} alt={image.title} className="gallery-image" />
                <div className="gallery-overlay">
                  <p className="gallery-title">{image.title}</p>
                </div>
              </motion.div>
            </Parallax>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
